import { FadeUp, RevealLine } from "./AnimatedSection";
import { useLanguage } from "@/context/LanguageContext";

export const Process = () => {
  const { t } = useLanguage();

  return (
    <section id="proceso" data-testid="process-section" className="relative py-28 md:py-36 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16 md:mb-24 max-w-2xl">
          <p className="text-brand-red text-xs font-mono tracking-[0.25em] font-semibold uppercase mb-4">{t.process.chapterLabel}</p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white tracking-tight">
            <RevealLine text={t.process.title} />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/[0.06] border border-white/[0.06]">
          {t.process.steps.map((step, i) => (
            <FadeUp key={step.number} delay={i * 0.08} className="relative bg-[#0A0A0A] p-8 md:p-12 group overflow-hidden">
              <span className={`absolute -top-4 -left-2 text-[7rem] md:text-[9rem] font-heading font-black leading-none select-none ${i % 2 === 0 ? "text-brand-blue/[0.06]" : "text-brand-red/[0.06]"}`}>
                {step.number}
              </span>
              <div className="relative z-10">
                <p className="font-heading text-white/40 text-sm font-bold mb-6 tracking-widest">{step.number}</p>
                <h3 data-testid={`process-step-title-${step.number}`} className="font-heading text-2xl font-bold text-white mb-3">
                  {step.title}
                </h3>
                <p className="text-neutral-400 text-[15px] leading-relaxed max-w-sm">{step.desc}</p>
              </div>
              <div className={`absolute bottom-0 left-0 h-[2px] w-0 group-hover:w-full transition-all duration-500 ${i % 2 === 0 ? "bg-brand-blue" : "bg-brand-red"}`} />
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
